import Debug from "debug";

import { ACTIONS } from "./constants";
import {
  PayloadEditorAuth,
  ActionEditorAuthGet,
  PayloadChannelEditOne,
  ActionChannelEditOne,
  ActionEditorPasswordAuthGet,
  ActionEditorPublicPrivateAuthGet,
} from "../types";
import { ScreenCloudLogger } from "../ScreenCloudReactApp";

const debug = Debug("broadcast:actions:auth");

export const getEditorAuth = (
  payload: PayloadEditorAuth
): ActionEditorAuthGet => {
  debug("getEditorAuth", payload);
  return {
    type: ACTIONS.EDITOR_AUTH_REQUEST,
    payload,
  };
};

export const removeEditorAuth = (
  payload: PayloadChannelEditOne,
  logger?: ScreenCloudLogger
): ActionChannelEditOne => {
  debug("removeEditorAuth", payload);
  return {
    type: ACTIONS.EDITOR_AUTH_REMOVE_REQUEST,
    payload,
    logger,
  };
};

export const addPasswordAuth = (
  payload: PayloadChannelEditOne,
  logger?: ScreenCloudLogger
): ActionEditorPasswordAuthGet => {
  debug("addPasswordAuth", payload);
  return {
    type: ACTIONS.EDITOR_PASSWORD_AUTH_REQUEST,
    payload,
    logger,
  };
};

export const addPublicPrivateAuth = (
  payload: PayloadChannelEditOne,
  logger?: ScreenCloudLogger
): ActionEditorPublicPrivateAuthGet => {
  debug("addPublicPrivateAuth", payload);
  return {
    type: ACTIONS.EDITOR_PUBLIC_PRIVATE_AUTH_REQUEST,
    payload,
    logger,
  };
};
